import React from 'react';
import Select from 'react-select';

const OrderActions = ({
  isLoading,
  selectedProductType,
  onCancel,
  newOrder,
  companies,
  selectedFirma,
  setSelectedFirma,
  lastSentFirma,
  selectedFirmaKumas,
  setSelectedFirmaKumas,
  lastSentFirmaKumas,
  selectedFirmaMekanizma,
  setSelectedFirmaMekanizma,
  lastSentFirmaMekanizma,
  selectedFirmaMotor,
  setSelectedFirmaMotor,
  lastSentFirmaMotor,
  selectedFirmaAksesuar,
  setSelectedFirmaAksesuar,
  lastSentFirmaAksesuar,
  selectedFirmaOzelTasarim,
  setSelectedFirmaOzelTasarim,
  lastSentFirmaOzelTasarim,
  selectedFirmaAstar,
  setSelectedFirmaAstar,
  lastSentFirmaAstar,
  handleWhatsAppSend,
  handleMultiWhatsAppSend,
  customSelectStyles
}) => {
  const isTulKanat = selectedProductType === 'tul' || selectedProductType === 'kanat';
  const isKanat = selectedProductType === 'kanat';
  const isKatlamali = selectedProductType === 'katlamaliPerde';

  // Tül/Kanat: aksesuar veya özel tasarım varsa çoklu firma göster
  const hasAccessories = Array.isArray(newOrder.accessories) && newOrder.accessories.length > 0;
  const hasOzelTasarim = isKanat && (newOrder.hasOzelTasarim || newOrder.ozelProductName);
  const hasAstar = isKanat && (newOrder.hasAstar || newOrder.astarProductName);

  // Tül/Kanat çoklu firma satırlarını dinamik olarak oluştur
  const showTulKanatMultiFirma = isTulKanat && (hasAccessories || hasOzelTasarim || hasAstar);

  const tulKanatFirmaItems = [];
  if (showTulKanatMultiFirma) {
    // Her zaman kumaş firması satırı göster
    tulKanatFirmaItems.push({
      id: 'kumas',
      label: 'Kumaş Firması',
      icon: 'fas fa-tshirt',
      color: '#6366f1',
      value: selectedFirma,
      setter: setSelectedFirma,
      lastSent: lastSentFirma
    });

    // Kanat + özel tasarım varsa
    if (hasOzelTasarim) {
      tulKanatFirmaItems.push({
        id: 'ozelTasarim',
        label: 'Özel Tasarım Firması',
        icon: 'fas fa-magic',
        color: '#f59e0b',
        value: selectedFirmaOzelTasarim,
        setter: setSelectedFirmaOzelTasarim,
        lastSent: lastSentFirmaOzelTasarim
      });
    }

    if (hasAstar) {
      tulKanatFirmaItems.push({
        id: 'astar',
        label: 'Astar Firması',
        icon: 'fas fa-layer-group',
        color: '#0f766e',
        value: selectedFirmaAstar,
        setter: setSelectedFirmaAstar,
        lastSent: lastSentFirmaAstar
      });
    }

    // Aksesuar varsa
    if (hasAccessories) {
      tulKanatFirmaItems.push({
        id: 'aksesuar',
        label: 'Aksesuar Firması',
        icon: 'fas fa-tags',
        color: '#10b981',
        value: selectedFirmaAksesuar,
        setter: setSelectedFirmaAksesuar,
        lastSent: lastSentFirmaAksesuar
      });
    }
  }

  // Katlamalı Perde için firma satırları
  const katlamaliFirmaItems = isKatlamali ? [
    { id: 'kumas', label: 'Kumaş Firması', icon: 'fas fa-tshirt', color: '#6366f1', value: selectedFirmaKumas, setter: setSelectedFirmaKumas, lastSent: lastSentFirmaKumas },
    { id: 'mekanizma', label: 'Mekanizma Firması', icon: 'fas fa-cogs', color: '#8b5cf6', value: selectedFirmaMekanizma, setter: setSelectedFirmaMekanizma, lastSent: lastSentFirmaMekanizma },
    { id: 'motor', label: 'Motor Firması', icon: 'fas fa-bolt', color: '#f59e0b', value: selectedFirmaMotor, setter: setSelectedFirmaMotor, lastSent: lastSentFirmaMotor },
    { id: 'aksesuar', label: 'Aksesuar Firması', icon: 'fas fa-tags', color: '#10b981', value: selectedFirmaAksesuar, setter: setSelectedFirmaAksesuar, lastSent: lastSentFirmaAksesuar }
  ] : [];

  const isFormReady = selectedProductType && (newOrder.productName || (selectedProductType === 'plise' && newOrder.pliseProduct1Name)) && newOrder.roomName;

  return (
    <div className="form-actions">
      {/* Kaydet / İptal Butonları — her zaman üstte */}
      <div className="action-buttons">
        <button
          type="submit"
          className="save-btn"
          disabled={isLoading || !selectedProductType}
        >
          {isLoading ? 'Kaydediliyor...' : 'Kaydet'}
        </button>
        <button
          type="button"
          onClick={onCancel}
          className="cancel-btn"
          disabled={isLoading}
        >
          İptal
        </button>
      </div>

      {/* WhatsApp Firma Seçimi Bölümü — butonların altında */}
      {isFormReady && (
        <div className="whatsapp-section-below">
          {/* ─── Katlamalı Perde: 4'lü Grid ─── */}
          {isKatlamali && (
            <div className="multi-firma-container">
              <div className="multi-firma-header">
                <i className="fab fa-whatsapp"></i>
                <span>Firma Seçimi & WhatsApp Gönderimi</span>
              </div>
              <div className="multi-firma-grid">
                {katlamaliFirmaItems.map((item) => (
                  <div key={item.id} className="firma-card">
                    <div className="firma-card-header">
                      <div className="firma-card-label">
                        <i className={item.icon} style={{ color: item.color }}></i>
                        <span>{item.label}</span>
                      </div>
                      {item.lastSent && (
                        <span className="firma-card-sent">
                          <i className="fas fa-check-circle"></i> {item.lastSent.name}
                        </span>
                      )}
                    </div>
                    <div className="firma-card-controls">
                      <Select
                        options={companies.map(firma => ({ value: firma.id, label: firma.name }))}
                        value={item.value ? { value: item.value, label: companies.find(f => f.id === item.value)?.name } : null}
                        onChange={(option) => item.setter(option ? option.value : '')}
                        className="firma-select"
                        isDisabled={isLoading}
                        isClearable
                        isSearchable
                        placeholder="Firma Seçin"
                        noOptionsMessage={() => "Firma bulunamadı"}
                        filterOption={(option, inputValue) => option.label.toLowerCase().includes(inputValue.toLowerCase())}
                        styles={customSelectStyles}
                      />
                      <button
                        type="button"
                        onClick={() => handleMultiWhatsAppSend(item.id)}
                        disabled={!item.value || isLoading}
                        className="whatsapp-btn whatsapp-btn-compact"
                        title={`${item.label} bilgilerini gönder`}
                      >
                        <i className="fab fa-whatsapp"></i>
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* ─── Tül/Kanat: Çoklu Firma (aksesuar ve/veya özel tasarım varsa) ─── */}
          {showTulKanatMultiFirma && (
            <div className="multi-firma-container">
              <div className="multi-firma-header">
                <i className="fab fa-whatsapp"></i>
                <span>Firma Seçimi & WhatsApp Gönderimi</span>
              </div>
              <div className="multi-firma-grid">
                {tulKanatFirmaItems.map((item) => (
                  <div key={item.id} className="firma-card">
                    <div className="firma-card-header">
                      <div className="firma-card-label">
                        <i className={item.icon} style={{ color: item.color }}></i>
                        <span>{item.label}</span>
                      </div>
                      {item.lastSent && (
                        <span className="firma-card-sent">
                          <i className="fas fa-check-circle"></i> {item.lastSent.name}
                        </span>
                      )}
                    </div>
                    <div className="firma-card-controls">
                      <Select
                        options={companies.map(firma => ({ value: firma.id, label: firma.name }))}
                        value={item.value ? { value: item.value, label: companies.find(f => f.id === item.value)?.name } : null}
                        onChange={(option) => item.setter(option ? option.value : '')}
                        className="firma-select"
                        isDisabled={isLoading}
                        isClearable
                        isSearchable
                        placeholder="Firma Seçin"
                        noOptionsMessage={() => "Firma bulunamadı"}
                        filterOption={(option, inputValue) => option.label.toLowerCase().includes(inputValue.toLowerCase())}
                        styles={customSelectStyles}
                      />
                      <button
                        type="button"
                        onClick={() => handleMultiWhatsAppSend(item.id)}
                        disabled={!item.value || isLoading}
                        className="whatsapp-btn whatsapp-btn-compact"
                        title={`${item.label} bilgilerini gönder`}
                      >
                        <i className="fab fa-whatsapp"></i>
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* ─── Diğer Ürünler (veya Tül/Kanat çoklu firma koşulu yoksa): Standart Tekli ─── */}
          {!isKatlamali && !showTulKanatMultiFirma && (
            <div className="single-firma-container">
              <div className="single-firma-header">
                <i className="fab fa-whatsapp"></i>
                <span>Firma Seçimi & WhatsApp Gönderimi</span>
              </div>
              {lastSentFirma && (
                <div className="whatsapp-info">
                  <i className="fas fa-check-circle"></i>
                  <span>{lastSentFirma.name} firmasına bilgiler iletildi</span>
                </div>
              )}
              <div className="whatsapp-controls">
                <Select
                  options={companies.map(firma => ({ value: firma.id, label: firma.name }))}
                  value={selectedFirma ? { value: selectedFirma, label: companies.find(f => f.id === selectedFirma)?.name } : null}
                  onChange={(option) => setSelectedFirma(option ? option.value : '')}
                  className="firma-select"
                  isDisabled={isLoading}
                  isClearable
                  isSearchable
                  placeholder="Firma Seçin"
                  noOptionsMessage={() => "Firma bulunamadı"}
                  filterOption={(option, inputValue) => option.label.toLowerCase().includes(inputValue.toLowerCase())}
                  styles={customSelectStyles}
                />
                <button
                  type="button"
                  onClick={handleWhatsAppSend}
                  disabled={!selectedFirma || isLoading || !selectedProductType}
                  className="whatsapp-btn"
                  title="Seçilen firmaya WhatsApp ile gönder"
                >
                  <i className="fab fa-whatsapp"></i>
                  <span>Gönder</span>
                </button>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default OrderActions;
